import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.btoa.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
import { getApiBaseUrl } from "@/api/service.js";
import editUser from "./components/editUser";
import CityLevelModal from "./components/CityLevelModal";
import dayjs from "dayjs";
import { mapState } from "vuex";
import util from "@/libs/util.js";
import md5 from "js-md5";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-user",
  components: {
    editUser: editUser,
    CityLevelModal: CityLevelModal
  },
  computed: _objectSpread({}, mapState("d2admin/user", ["info"])),
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        userTypeAccountStatus: this.$route.query.status || 3,
        phone: this.$route.query.phone || "",
        name: "",
        remark: "",
        company: this.$route.query.company || "",
        city: []
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      dsx: 0,
      // 待认证
      authProcessCount: 0,
      // 认证中
      ysx: 0,
      // 已认证
      dq: 0,
      // 欠费人数
      zx: 0,
      // 在线
      currentRow: {},
      // 当前行
      remarkDialogVisible: false,
      // 备注弹窗
      amount: "",
      // 充值金额
      topUpDialogVisible: false,
      // 充值弹窗
      editVisible: false,
      editType: 1,
      // 1:编辑，2;开通，3:续费
      current: null,
      transferPhone: "",
      transferVisible: false,
      transferLoading: false,
      currentUserId: "",
      adminList: [],
      cityList: [],
      exportLoading: false,
      userAuthDialogVisible: false,
      userAuthDialogType: 1 // 1:去实名，2:重新实名
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getAdminList();
            _this.getCityList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    setLevel: function setLevel() {
      this.$refs.cityLevelModal.show();
    },
    showUserAuthDialog: function showUserAuthDialog(row, type) {
      this.userAuthDialogType = type;
      this.currentRow = row;
      this.userAuthDialogVisible = true;
    },
    setQuarterUserAuth: function setQuarterUserAuth(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.setQuarterUserAuth({
                phone: _this2.currentRow.phone
              });
            case 1:
              res = _context2.v;
              if (res.code === 4037) {
                _this2.$confirm("该用户的版本信息较老，暂不支持去实名哦", "注意", {
                  confirmButtonText: "好的",
                  cancelButtonText: "返回",
                  type: "warning"
                }).then(function () {
                  _this2.userAuthDialogVisible = false;
                });
              } else {
                // 操作上报
                _this2.$operationLog.push({
                  code: _this2.userAuthDialogType == 1 ? "identify" : "reidentify",
                  userId: _this2.currentRow.id,
                  operationType: "user"
                });
                _this2.userAuthDialogType = 1;
                _this2.$message.success("操作成功");
                _this2.userAuthDialogVisible = false;
                _this2.getData();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    exportData: function exportData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var javaApiSign, signKey, nonce, timestamp, str, signature;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!_this3.exportLoading) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _this3.exportLoading = true;
              javaApiSign = {};
              signKey = "19E3BDE5A03AD42B3FD81347CFFDF50E";
              nonce = 123456;
              timestamp = +new Date();
              str = "" + timestamp + nonce + signKey;
              signature = window.btoa(md5(str));
              javaApiSign = {
                nonce: nonce,
                timestamp: timestamp,
                signature: signature
              };
              axios.post("".concat(getApiBaseUrl(), "/api/v3/bq/user/exportBrandQuarterUser"), {
                adminId: util.cookies.get("uuid"),
                userTypeAccountStatus: _this3.searchForm.userTypeAccountStatus,
                phone: _this3.searchForm.phone,
                name: _this3.searchForm.name,
                remark: _this3.searchForm.remark,
                company: _this3.searchForm.company,
                city: _this3.searchForm.city
              }, {
                responseType: "blob",
                headers: _objectSpread({}, javaApiSign)
              }).then(function (res) {
                console.log('res=>', res);
                if (res.data.size > 300) {
                  var blob = new Blob([res.data], {
                    type: 'application/octet-stream;charset=utf-8'
                  });
                  var url = URL.createObjectURL(blob);
                  var link = document.createElement('a');
                  link.href = url;
                  link.download = "quarter_user_".concat(dayjs().format('YYYY-MM-DD'), ".xls");
                  link.click();
                  URL.revokeObjectURL(url);
                  // 操作上报
                  _this3.$operationLog.push({
                    operationType: "text",
                    code: "export"
                  });
                } else {
                  _this3.$message.error('操作无权限');
                }
                _this3.exportLoading = false;
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    goQuarterHouseList: function goQuarterHouseList(row) {
      window.open("#/quarter/house?phone=".concat(row.phone));
    },
    goQuarterOrderRecord: function goQuarterOrderRecord(row) {
      window.open("#/quarter/orderRecord?phone=".concat(row.phone));
    },
    getCityList: function getCityList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getCityListByPy();
            case 1:
              res = _context4.v;
              _this4.cityList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getAdminList: function getAdminList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.getAdminUser({
                type: "operate"
              });
            case 1:
              res = _context5.v;
              _this5.adminList = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    sortChange: function sortChange(row) {
      console.log(row);
      if (row.order == "descending") {
        this.searchForm.endTimeOrder = "DESC";
      } else if (row.order == "ascending") {
        this.searchForm.endTimeOrder = "ASC";
      } else {
        this.searchForm.endTimeOrder = "";
      }
      this.getData();
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRow = row;
      this.remarkDialogVisible = true;
    },
    goApartmentAudit: function goApartmentAudit(row) {
      window.open("#/quarter/apartment/audit?phone=".concat(row.phone, "&brandStatus=all"));
    },
    // 退款
    brandAccountRefund: function brandAccountRefund(row) {
      var _this6 = this;
      this.$confirm("退款", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.brandAccountRefund({
                userId: row.id
              });
            case 1:
              _this6.getData();
              _this6.$message.success("操作成功");
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      })));
    },
    // 通过认证
    setUserTypeStatus: function setUserTypeStatus(row, status) {
      var _this7 = this;
      this.$confirm("通过品牌认证", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this7.$api.setUserTypeStatus({
                user_id: row.id,
                user_type_status: status
              });
            case 1:
              _this7.getData();
              _this7.$message.success("操作成功");
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      })));
    },
    // 品牌充值
    brandTopUp: function brandTopUp() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this8.$api.brandTopUp({
                userId: _this8.currentRow.id,
                amount: _this8.amount
              });
            case 1:
              _this8.$message.success("充值成功");
              _this8.getData();
              _this8.amount = "";
              _this8.topUpDialogVisible = false;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (type === "search") {
                _this9.searchForm.pageNum = 1;
              }
              _this9.tableLoading = true;
              _context9.n = 1;
              return _this9.$api.findAllBrandQuarterUser(_this9.searchForm);
            case 1:
              res = _context9.v;
              res.data.list.forEach(function (item) {
                var _item$authInfoRecords;
                item.user = {
                  id: item.id,
                  avatar: item.avatar,
                  phone: item.phone,
                  name: item.name,
                  remark: item.remark,
                  disable_send_msg_at: item.disableSendMsgAt,
                  user_type: item.userType,
                  user_type_status: item.userTypeStatus,
                  user_type_account_status: item.userTypeAccountStatus,
                  landlord_status: item.landlordStatus,
                  tenant_status: item.tenantStatus,
                  scene: item.scene
                };
                item.createTime = dayjs(item.createTime * 1000).format("YYYY-MM-DD HH:mm:ss");
                if ((item === null || item === void 0 || (_item$authInfoRecords = item.authInfoRecords) === null || _item$authInfoRecords === void 0 ? void 0 : _item$authInfoRecords.length) > 0) {
                  item.authInfoRecords.forEach(function (record) {
                    record.createdAt = dayjs(record.createdAt).format("YYYY-MM-DD");
                  });
                }
              });
              _this9.tableData = res.data.list;
              _this9.total = res.data.totalCount;
              _this9.dsx = res.data.dsx;
              _this9.authProcessCount = res.data.authProcessCount;
              _this9.ysx = res.data.ysx;
              _this9.dq = res.data.dq;
              _this9.zx = res.data.zx;
              _this9.tableLoading = false;
              _this9.getUserScoreList(_this9.tableData);
              _this9.getUserListByIds(_this9.tableData, "id");
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getUserScoreList: function getUserScoreList(data) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var userIds, res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              userIds = [];
              data.forEach(function (item) {
                var _item$user;
                if (((_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.user_type) === 3) userIds.push(item.user.id);
              });
              userIds = _toConsumableArray(new Set(userIds));
              if (userIds.length) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              _context0.n = 2;
              return _this0.$api.queryQuarterScoreById({
                userIds: userIds
              });
            case 2:
              res = _context0.v;
              if (res && res.data.length) {
                _this0.tableData.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.user.id;
                  });
                  _this0.$set(item.user, 'userScore', userScore || {});
                });
              }
            case 3:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    add: function add() {
      var _this1 = this;
      this.$prompt("手机号", "新增品牌季度用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "手机号不能为空"
      }).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref3) {
          var value, res;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                value = _ref3.value;
                _context1.n = 1;
                return _this1.$api.addBqOpenAccount({
                  phone: value,
                  adminId: util.cookies.get("uuid")
                });
              case 1:
                res = _context1.v;
                _this1.$message.success("操作成功");
                _this1.getData();
                // 操作上报
                _this1.$operationLog.push({
                  code: "add",
                  userId: res.data,
                  operationType: "user"
                });
              case 2:
                return _context1.a(2);
            }
          }, _callee1);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function () {});
    },
    addRemarks: function addRemarks(row) {
      var _this10 = this;
      // addBqRemarks
      this.$prompt("", "添加备注", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputType: "textarea",
        inputErrorMessage: "备注不能为空"
      }).then(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref5) {
          var value, res;
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                value = _ref5.value;
                _context10.n = 1;
                return _this10.$api.addBqRemarks({
                  phone: row.phone,
                  remark: value
                });
              case 1:
                res = _context10.v;
                _this10.$message.success("备注添加成功");
                _this10.getData();
              case 2:
                return _context10.a(2);
            }
          }, _callee10);
        }));
        return function (_x2) {
          return _ref6.apply(this, arguments);
        };
      }()).catch(function () {});
    },
    open: function open(row) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _this11.editType = 2;
              _this11.currentUserId = row.id;
              _context11.n = 1;
              return _this11.$api.checkOpenAccount({
                name: row.name,
                phone: row.phone
              });
            case 1:
              res = _context11.v;
              res.data.id = null;
              _this11.current = res.data;
              _this11.editVisible = true;
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    edit: function edit(row) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var res;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _this12.editType = 1;
              _this12.currentUserId = row.id;
              _context12.n = 1;
              return _this12.$api.findBrandQuarterOrderByPhone({
                phone: row.phone
              });
            case 1:
              res = _context12.v;
              _this12.current = res.data;
              _this12.editVisible = true;
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    renew: function renew(row) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var res;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _this13.editType = 3;
              _this13.currentUserId = row.id;
              _context13.n = 1;
              return _this13.$api.findBrandQuarterOrderByPhoneForRenewal({
                phone: row.phone
              });
            case 1:
              res = _context13.v;
              res.data.id = null;
              _this13.current = res.data;
              _this13.editVisible = true;
            case 2:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    queryTransfer: function queryTransfer() {
      var _this14 = this;
      this.transferLoading = true;
      this.$api.checkTransferAccount({
        newPhone: this.transferPhone,
        oldPhone: this.current.phone
      }).then(function (res) {
        _this14.$prompt("\n                        <strong>\u8001\u8D26\u53F7\uFF08".concat(res.data.oldName, "\uFF09</strong>\n                        <ul>\n                            <li>\u8FDB\u5165\u201C\u5230\u671F\u201D</li>\n                            <li>\u8BA2\u5355\u65F6\u95F4\uFF1A").concat(res.data.oldStartTime, " - ").concat(res.data.oldEndTime, "</li>\n                            <li>\u8BA2\u5355\u91D1\u989D\uFF1A").concat(res.data.oldAmount || 0, "</li>\n                        </ul>\n                        <strong>\u65B0\u8D26\u53F7\uFF08").concat(res.data.name, "\uFF09</strong>\n                        <ul>\n                            <li>\u8FDB\u5165\u201C\u5728\u7EBF\u201D</li>\n                            <li>\u8BA2\u5355\u65F6\u95F4\uFF1A").concat(res.data.newStartTime, " - ").concat(res.data.newEndTime, "</li>\n                            <li>\u8BA2\u5355\u91D1\u989D\uFF1A").concat(res.data.newAmount || 0, "</li>\n                        </ul>\n                    "), "转移细节", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          showInput: false,
          beforeClose: function () {
            var _beforeClose = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(action, instance, done) {
              return _regenerator().w(function (_context14) {
                while (1) switch (_context14.n) {
                  case 0:
                    if (action === "confirm") {
                      res.data.createName = _this14.info.name;
                      instance.confirmButtonLoading = true;
                      instance.confirmButtonText = "转移中...";
                      _this14.$api.saveTransferAccount(res.data).then(function (res1) {
                        _this14.$message.success("转移成功");
                        instance.confirmButtonLoading = false;
                        instance.confirmButtonText = "确认";
                        _this14.transferLoading = false;
                        _this14.transferVisible = false;
                        _this14.getData();

                        // 操作上报
                        _this14.$operationLog.push({
                          code: "transfer",
                          userId: res1.data,
                          operationType: "order",
                          operationOrderType: "quarter"
                        });
                        _this14.$api.setRiskDeviceAndCategory({
                          'user_id': res.data.userId
                        });
                        done();
                      }).catch(function (err) {
                        instance.confirmButtonLoading = false;
                        instance.confirmButtonText = "确认";
                      });
                    } else {
                      _this14.transferLoading = false;
                      done();
                    }
                  case 1:
                    return _context14.a(2);
                }
              }, _callee14);
            }));
            function beforeClose(_x3, _x4, _x5) {
              return _beforeClose.apply(this, arguments);
            }
            return beforeClose;
          }()
        });
      }).catch(function (err) {
        _this14.transferLoading = false;
      });
    },
    transfer: function transfer(row) {
      var _row$user;
      var level = (_row$user = row.user) === null || _row$user === void 0 || (_row$user = _row$user.userScore) === null || _row$user === void 0 ? void 0 : _row$user.level;
      if (level && ["D"].includes(level || '')) {
        return this.$message.error("该季度用户等级为D级，直到下次评级前无法转移。");
      }
      this.current = Object.assign({}, row);
      this.transferPhone = "";
      this.transferVisible = true;
    },
    cancel: function cancel(row) {
      var _this15 = this;
      this.$confirm("取消季度用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var res;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return _this15.$api.cancelBq({
                phone: row.phone,
                adminId: util.cookies.get("uuid")
              });
            case 1:
              res = _context15.v;
              _this15.$message.success("取消季度用户成功");
              _this15.getData();

              // 操作上报
              _this15.$operationLog.push({
                code: "cancel",
                userId: row.id,
                operationType: "user"
              });
            case 2:
              return _context15.a(2);
          }
        }, _callee15);
      }))).catch(function () {});
    },
    stop: function stop(row) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var res;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _context17.n = 1;
              return _this16.$api.checkStopAccount({
                phone: row.phone
              });
            case 1:
              res = _context17.v;
              _this16.$confirm("\n                    <strong>\u8D26\u53F7\uFF08".concat(row.name, "\uFF09</strong>\n                    <ul>\n                        <li>\u8FDB\u5165\u201C\u5F85\u4E0A\u7EBF\u201D</li>\n                        <li>\u62BC\u91D1\u91D1\u989D\uFF1A").concat(res.data.deposit || 0, "</li>\n                        <li>\u8BA2\u5355\u65F6\u95F4\uFF1A").concat(res.data.oldStartTime, " - ").concat(res.data.oldEndTime, "\u3010").concat(res.data.days, "\u5929\u3011</li>\n                        <li>\u5269\u4F59\u65F6\u95F4\uFF1A").concat(res.data.remainDays || 0, "</li>\n                        <li>\u5DF2\u7528\u91D1\u989D\uFF1A").concat(res.data.oldAmount || 0, "</li>\n                        <li>\u5269\u4F59\u91D1\u989D\uFF1A").concat(res.data.oldAmountRemain || 0, "</li>\n                    </ul>\n                "), "停用细节", {
                confirmButtonText: "停用",
                confirmButtonClass: "el-button--danger",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
                var res1;
                return _regenerator().w(function (_context16) {
                  while (1) switch (_context16.n) {
                    case 0:
                      _context16.n = 1;
                      return _this16.$api.saveStopAccount(res.data);
                    case 1:
                      res1 = _context16.v;
                      _this16.$message.success("停用成功");
                      // 备注
                      _context16.n = 2;
                      return _this16.$api.setUserRemark({
                        userId: row.id,
                        remark: "\u505C\u7528\u65F6\u8BE5\u8D26\u53F7\u5269\u4F59".concat(res.data.remainDays, "\u5929\uFF0C\u5269\u4F59").concat(res.data.oldAmountRemain, "\u5143")
                      });
                    case 2:
                      _this16.getData();

                      // 操作上报
                      _this16.$operationLog.push({
                        code: "deactivate",
                        userId: row.id,
                        operationType: "order",
                        operationOrderType: "quarter"
                      });
                    case 3:
                      return _context16.a(2);
                  }
                }, _callee16);
              }))).catch(function () {});
            case 2:
              return _context17.a(2);
          }
        }, _callee17);
      }))();
    },
    toPage: function toPage(row) {
      if (row !== null && row !== void 0 && row.idcardNumber) {
        window.open("#/user/real-name?number=".concat(row.idcardNumber));
      }
    }
  }
};